import './bootstrap';
import $ from 'jquery';
window.$ = window.jQuery = $;
import jconfirm from 'jquery-confirm';
window.jconfirm = jconfirm;
import.meta.glob([
    '../assets/img/**',
    '../assets/fonts/**',
]);
